module.exports = __webpack_public_path__ + "static/img/kfwx.78f341c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kfwx.jpg
// module id = r14k
// module chunks = 1